<div class="user-list-content">
  <div>
    <app-table
      [items]="userList"
      [loading]="loading"
      [deleteTitle]="tk.User.UserTitleDeleteConfirmation | t"
      [columnDefinitions]="columnDefinitions"
      [permissions]="userPermissions"
      [totalRecords]="pagination.total"
      [rows]="pagination.itemsPerPage || 5"
      [sortable]="true"
      [rowClassFunction]="rowClass"
      [title]="'Usuários'"
      [showSearch]="true"
      [searchPlaceholder]="'Buscar nome ou e-mail'"
      [hasFilter]="true"
      (sendTableFilter)="sendSearch.emit($event)"
      (sendOpenFilter)="sendOpenFilter.emit()"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"
      (sendTableSort)="handleTableSort($event)">
      <!-- Nome com as iniciais; com User.UPDATE é link para o cadastro (abre em nova aba com Ctrl/clique do meio) -->
      <ng-template appNamedTemplate="name" let-item>
        @if (canEdit && !isInactive(item)) {
          <a
            class="user-list-content__user user-list-content__user--link"
            [routerLink]="['/dashboard/user/register', item.id]"
            [title]="'Editar ' + displayName(item)">
            <span class="user-list-content__avatar" aria-hidden="true">{{ initials(item) }}</span>
            <span class="user-list-content__name">{{ displayName(item) }}</span>
          </a>
        } @else {
          <span class="user-list-content__user">
            <span class="user-list-content__avatar" aria-hidden="true">{{ initials(item) }}</span>
            <span class="user-list-content__name">{{ displayName(item) }}</span>
          </span>
        }
      </ng-template>

      <!-- Perfil como etiqueta, com cor por tipo de perfil -->
      <ng-template appNamedTemplate="roles" let-item>
        <span class="user-list-content__roles">
          @for (role of item.roles; track role.id) {
            <span class="user-list-content__role" [ngClass]="roleTagClass(role.name)">
              {{ role.name }}
            </span>
          }
        </span>
      </ng-template>

      <!-- Template customizado para company -->
      <!-- Sem empresa direta: grupo econômico (Modo 2) ou quantidade de empresas (Modo 3) -->
      <ng-template appNamedTemplate="company" let-item let-value="value">
        @if (item.company) {
          <span>{{ item.company.displayName || item.company.tradeName }}</span>
        } @else if (item.economicGroup) {
          <span class="user-list-content__group">
            <span class="user-list-content__group-tag">Grupo</span>
            <span
              class="user-list-content__scope"
              [pTooltip]="scopeCompaniesTooltip(item)"
              tooltipPosition="top"
              tooltipStyleClass="long-text-tooltip">
              {{ item.economicGroup.name }}
            </span>
          </span>
        } @else if (item.companyAccessCount > 0) {
          <span
            class="user-list-content__scope"
            [pTooltip]="scopeCompaniesTooltip(item)"
            tooltipPosition="top"
            tooltipStyleClass="long-text-tooltip">
            {{ item.companyAccessCount }}
            {{ item.companyAccessCount === 1 ? 'empresa' : 'empresas' }}
          </span>
        }
      </ng-template>

      <!-- Template customizado para tenant -->
      <ng-template appNamedTemplate="tenant" let-item let-value="value">
        <span>{{ item.tenant?.name }}</span>
      </ng-template>

      <!-- Último acesso; quem nunca entrou ganha o texto em vez de vazio -->
      <ng-template appNamedTemplate="lastLogin" let-item let-value="value">
        @if (value) {
          <span>{{ value | vaultDateTime }}</span>
        } @else {
          <span class="user-list-content__muted">Nunca entrou</span>
        }
      </ng-template>

      <!-- Status: Ativo ou Inativo (inativado = antiga exclusão lógica, card 3697) -->
      <ng-template appNamedTemplate="status" let-item>
        @if (isInactive(item)) {
          <span
            class="user-list-content__status user-list-content__status--inactive"
            [pTooltip]="'Inativado em ' + (item.deletedAt | vaultDateTime)"
            tooltipPosition="top">
            Inativo
          </span>
        } @else {
          <span class="user-list-content__status user-list-content__status--active">Ativo</span>
        }
      </ng-template>

      <!-- Senha: definida, sem senha ou com o link de criação vencido -->
      <ng-template appNamedTemplate="hasPassword" let-item>
        @let password = passwordState(item);
        <span class="user-list-content__password">
          <i
            class="pi"
            [ngClass]="password.icon + ' user-list-content__password--' + password.tone"
            [pTooltip]="password.tooltip"
            tooltipPosition="top"></i>
        </span>
      </ng-template>

      <!-- Ações da linha: todas no menu ⋯ (Editar e Tokens de API no topo). Template próprio porque o
           cache de menu do app-table só zera quando a lista muda, e as permissões chegam depois. -->
      <ng-template appNamedTemplate="rowActions" let-item>
        <app-action-menu
          [items]="menuFor(item)"
          (sendItemClick)="emitRowAction($any($event)['action'], item)"></app-action-menu>
      </ng-template>
    </app-table>
  </div>
  <!-- Modal para gerenciar API Tokens -->
  <app-modal-api-tokens #apiTokensModal (actionCompleted)="onApiTokensActionCompleted()">
  </app-modal-api-tokens>
</div>
